import { MDCBanner } from '@material/banner'
import { iconCssClasses } from '@material/textfield'

export default {
  setup() {
    this.banner = new MDCBanner(this.el)
  },
  destroy() {
    this.banner?.destroy()
    this.banner = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
